export default store => store.data.users;
